module.exports = __webpack_public_path__ + "static/media/about2.f75526d8.webp";